"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    BaseDomainIDService: ()=>BaseDomainIDService
});
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class BaseDomainIDService {
    calcDomainID() {
        if (this.props.url) {
            var _this_props_calcDomainID, _this_props;
            const urlObj = new URL(this.props.url);
            this._domainID = this.props.hostnameMap[urlObj.hostname] || (null == (_this_props_calcDomainID = (_this_props = this.props).calcDomainID) ? void 0 : _this_props_calcDomainID.call(_this_props, urlObj));
        }
    }
    triggerException(position, message) {
        if ('function' == typeof this.props.triggerException) this.props.triggerException(position, message);
        throw new Error(`[BaseDomainIDService] ${position}: ${message}`);
    }
    is(value) {
        return value === this._domainID;
    }
    get currentDomainID() {
        return this._domainID;
    }
    getCurrentDomainID() {
        if (!this._domainID) this.triggerException('getCurrentDomainID', 'failed');
        return this._domainID;
    }
    getRegion() {
        let domainID = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this._domainID;
        const { regionEnvMap } = this.props;
        if (!regionEnvMap) this.triggerException('getRegion', 'please set regionEnvMap first');
        if (!domainID || !regionEnvMap[domainID]) this.triggerException('getRegion', `DomainID ${domainID} is invalid`);
        return regionEnvMap[domainID].region;
    }
    getEnv() {
        let domainID = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this._domainID;
        const { regionEnvMap } = this.props;
        if (!regionEnvMap) this.triggerException('getEnv', 'please set regionEnvMap first');
        if (!domainID || !regionEnvMap[domainID]) this.triggerException('getEnv', `DomainID ${domainID} is invalid`);
        return regionEnvMap[domainID].env;
    }
    constructor(props){
        _define_property(this, "props", void 0);
        _define_property(this, "_domainID", void 0);
        this.props = props;
        this._domainID = void 0;
        this.calcDomainID();
    }
}
exports.BaseDomainIDService = __webpack_exports__.BaseDomainIDService;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "BaseDomainIDService"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
